import { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export type PasswordFieldProps = Omit<TextFieldProps, 'type' | 'InputProps'>;

/**
 * MUI TextField with a "reveal" eye icon that toggles between
 * type="password" and type="text". Accepts every TextField prop except
 * the two we control (type / InputProps).
 */
export function PasswordField(props: PasswordFieldProps) {
  const [shown, setShown] = useState(false);
  return (
    <TextField
      {...props}
      type={shown ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShown((v) => !v)}
              edge="end"
              size="small"
              aria-label={shown ? 'Hide password' : 'Show password'}
              tabIndex={-1}
            >
              {shown ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
